<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Falter im Schnee</h3>
<p class="vers">Novembersturm in wildem Wirbeltanze<br class="calibre2"/>
treibt Flocken übers Feld und durch die Tannen,<br class="calibre2"/>
schneeschwere Wolken düster rings umspannen<br class="calibre2"/>
das Firmament mit grauem Nebelglanze.</p>
<p class="vers">Ich nehme Hut und Stab und warme Hülle<br class="calibre2"/>
und pfeife schreitend meinen flinken Hunden,<br class="calibre2"/>
um auszuwandern meine Ruhestunden<br class="calibre2"/>
in weißumwehten Forstes Winterstille.</p>
<p class="vers">Der Leithund schnobert ruhlos durch die
Stämme;<br class="calibre2"/>
das Wachtelhündchen trollt an meiner Seite.<br class="calibre2"/>
Ich schicke die Gedanken in die Weite,<br class="calibre2"/>
traumferne schreitend über Bergeskämme.</p>
<p class="vers">Zur Jugend ging ich und zum später Alter<br class="calibre2"/>
auf ungesehner und geheimer Fährte;<br class="calibre2"/>
bis ich zurück zu jener Stätte kehrte,<br class="calibre2"/>
wo am Wacholder saß erstarrt ein Falter.</p>
<p class="vers">Ich nahm ihn auf; und seine güldnen Schwingen<br class="calibre2"/>
leis schonend, legt' ich ihn in meine Hände,<br class="calibre2"/>
wo seines Kerkers lebenswarme Wände<br class="calibre2"/>
begannen ihn mit Wonne zu durchdringen.</p>
<p class="vers">Er lebte auf, und er begann zu regen<br class="calibre2"/>
das Schwingenpaar und suchte zu entweichen,<br class="calibre2"/>
ich aber schnell mein Zimmer zu erreichen,<br class="calibre2"/>
wo ich gedachte seiner treu zu pflegen.</p>
<p class="vers">Doch vor der Pforte zeigt' ich meinem Weibe,<br class="calibre2"/>
was ich gefunden, öffnend meine Finger,<br class="calibre2"/>
und schnell benutzt's der kleine Flügelschwinger<br class="calibre2"/>
zu seiner Flucht mit neu gestärktem Leibe.</p>
<p class="vers">Er hebt sich, regt mit Kraft die güldnen
Flügel<br class="calibre2"/>
zu unsrem Staunen durch die grauen Lüfte,<br class="calibre2"/>
befreit sich wähnend, spottend seiner Grüfte,<br class="calibre2"/>
gradweges taumelnd nach dem Grabeshügel.</p>
<p class="vers"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page26" title="wedi/Konmax"></a> Nie war die Freiheit näher beim Verderben!<br class="calibre2"/>
Nie war die Wonne näher bei dem Wehe!<br class="calibre2"/>
Nie war der Frühling näher bei dem Schneee!<br class="calibre2"/>
Nie war das Leben näher bei dem Sterben!</p>
<p class="vers">Und rufen hört' ich tausend Frühlingsgeister,<br class="calibre2"/>
indes der Sturm zerwühlte meine Locken,<br class="calibre2"/>
indes ich starrte in das Spiel der Flocken:<br class="calibre2"/>
du warst ein lässig-schlechter Kerkermeister.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0011.vue?66c37f06